export default __webpack_public_path__ + "static/media/46678.786d907e.jpg";